import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'callback',
    pure: false
})
export class CallbackPipe implements PipeTransform {
    transform(items: any[], callback: (item: any) => boolean): any {
        return (!items || !callback) ? items : items.filter(item => callback(item));
    }
}
